import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '@aws-amplify/ui-react';
import { Amplify } from 'aws-amplify';
import './index.css';
import '@aws-amplify/ui-react/styles.css';
import amplifyConfig from './auth/amplifyConfig';
import { configureAuthSessionStorage } from './auth/sessionStorage';
import App from './App';
import reportWebVitals from './reportWebVitals';

// Required as of Amplify v6
Amplify.configure(amplifyConfig);
configureAuthSessionStorage();

// CSS imports are probably here so failures can be detected.
// Amplify styles are imported twice, once here and once at the top of the file.
// This *might* be so that Amplify styles are available during initialization, and then refreshed after.
// Orr it might be a mistake. Leaving it as-is for now.
import '@aws-amplify/ui-react/styles.css'; // default theme
import '@fontsource/roboto/300.css';
import '@fontsource/roboto/400.css';
import '@fontsource/roboto/500.css';
import '@fontsource/roboto/700.css';

// Get a reference to the HTML element with id="root" from public/index.html
// This is where our entire React application will be mounted
const container = document.getElementById('root');

// Create a React root container using React 18's new createRoot API
// This is the entry point for rendering React components
const root = createRoot(container);

// Render our React application into the root container
// StrictMode enables additional development-time checks
// ThemeProvider provides styling context for AWS Amplify UI components
// App is our main application component
root.render(
  <React.StrictMode>
    <ThemeProvider>
      <App />
    </ThemeProvider>
  </React.StrictMode>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
